export default "__VITE_ASSET__1bb710d5__"